export const REDUCER_NAME = 'process'




// WEBPACK FOOTER //
// ./src/modules/process/state/const.js